'use strict';

/**
 * BD.CustomPickup: Manage the custom pickup box during checkout
 */
var BD = window.BD = window.BD || {};
BD.CustomPickup = (function($) {
  var customPickupHandles = [ 'custom-pickup', 'custom-pickup-10plus' ];
  var attributeFields = ['Custom Pickup - Street', 'Custom Pickup - Apt', 'Custom Pickup - City', 'Custom Pickup - Postal Code', 'Custom Pickup - Phone', 'Custom Pickup - Special Instructions']
  var attrLocationIsSet = 'Custom Pickup - Location Is Set';

  var $customPickup;
  var $showButton;
  var $removeButton;
  var $locationPanel;
  var $locationDescription;
  var $locationForm;
  var $noAddressCheckbox;
  var customPickupHandle;
  var customPickupVariant;
  var customPickupCity;
  
  function showLocationForm() {
    $locationForm.addClass('shown');

    attributeFields.forEach(function(attrName) {
      var val = $locationForm.find('[name="attributes[' + attrName + ']"]').val(CartJS.getAttribute(attrName));
    });

    $noAddressCheckbox.prop('checked', CartJS.getAttribute(attrLocationIsSet) == 'NO');
    $locationForm.find('[name="attributes[Custom Pickup - City]"]').val(customPickupCity);
    toggleNoAddressCheckbox();

    $showButton.prop('disabled', true);
  }
  
  /**
   * Convenience method to convert a "short key" like "Street" and get the associated cart attribute value.
   */
  function attrValueFromShortKey(shortKey) { return CartJS.getAttribute('Custom Pickup - ' + shortKey); }
  function getStreet() { return attrValueFromShortKey('Street'); }
  function getApt() { return attrValueFromShortKey('Apt'); }
  function getCity() { return attrValueFromShortKey('City'); }
  function getPostal() { return attrValueFromShortKey('Postal Code'); }
  function getPhone() { return attrValueFromShortKey('Phone'); }
  function getSpecialInstructions() { return attrValueFromShortKey('Special Instructions'); }
  function hasNoAddress() { return !!$locationForm.find('#chk_customPickup_noAddress:checked').length; }

  function hideLocationForm() {
    $locationForm.removeClass('shown');
    $showButton.prop('disabled', false);
    updateUiState();    
  }
  
  function toggleNoAddressCheckbox() {
    var isDisabled = $noAddressCheckbox.is(':checked');
    $locationForm.find('input[type=text]:not(.locationForm__city),textarea').prop('disabled', isDisabled);
  }
  
  function editLocationForm() {
    $locationPanel.removeClass('shown');
    showLocationForm();
    $removeButton.hide();
  }
  
  function getCustomPickupCartItem() {
    var matchingItems = CartJS.cart.items.filter((item, idx) => {
      if (customPickupHandles.includes(item.handle)) {
        item.lineNumber = idx + 1;
        return true;
      }
      return false;
    });

    return matchingItems.length ? matchingItems[0] : null;
  }
  
  function hasPickupCartItem() {
    return !!getCustomPickupCartItem();
  }
  
  function displayLocationPanel() {
    var street = getStreet();
    var apt = getApt();
    var city = getCity();
    var province = 'ON'; // Hardcoded for now, since BD doesn't operate or pickup outside Ontario
    var postal = getPostal();
    var phone = getPhone();
    var html = '<div class="title">Your Custom Pickup Location:</div>';
    var instructions = getSpecialInstructions();
    var noAddress = hasNoAddress();
    
    if (noAddress) {
      html += "We'll contact you closer to the event to confirm a pickup location";
    }
    else {
      var line1 = [];
      if (street) { line1.push(htmlEscape(street)); }
      if (apt) { line1.push(htmlEscape(apt)); }
      var line1Html = (line1.length ? line1.join(', ') : null);
      
      var line2 = [];
      if (city) { line2.push(htmlEscape(city)); }
      if (province) { line2.push(htmlEscape(province)); }
      var line2Html = (line2.length ? line2.join(', ') : null);
      
      if (postal) { 
        var safePostal = htmlEscape(postal);
        line2Html = (line2Html ? (line2Html + " " + safePostal) : safePostal);
      }
      
      var line3Html = phone ? htmlEscape(phone) : null;
      var addrLines = [ line1Html, line2Html, line3Html ].filter((v) => v != null);
      
      html += addrLines.join('<br>');
    }
  
    if (instructions) {
      html += "<br /><div class='title'>Special Instructions</div>" + htmlEscape(instructions).replace(/\n/g, '<br />');
    }
    
    $locationDescription.html(html);
    $locationPanel.addClass('shown');
  }
  
  function removeCustomPickup() {
    var clearAttrs = { 'Has Custom Pickup': '' };
    clearAttrs[attrLocationIsSet] = '';
    
    attributeFields.forEach((attr) => { clearAttrs[attr] = ''; });
    CartJS.setAttributes(clearAttrs);
    
    var item = getCustomPickupCartItem();
    
    if (item) {
      CartJS.removeItem(item.lineNumber);
    }
    
    refreshAfterCartJsUpdate();
  }
  
  function confirmCustomPickup() {
    var noAddress = !!$locationForm.find('#chk_customPickup_noAddress:checked').length;
    var attrUpdates = { 'Has Custom Pickup': 'YES' };
    
    attrUpdates[attrLocationIsSet] = noAddress ? 'NO' : 'YES';
    
    // Loop through attribute names and move the values from the form to the cart attributes
    attributeFields.forEach(function(attrName) {
      var val = $locationForm.find('[name="attributes[' + attrName+ ']"]').val();
      attrUpdates[attrName] = val;
    });

    CartJS.setAttributes(attrUpdates);
    
    var item = getCustomPickupCartItem();
    
    if (!item) { 
      CartJS.addItem(customPickupVariant);
    }

    refreshAfterCartJsUpdate();
  }
  
  function refreshAfterCartJsUpdate() {
    $(document).one('cart.requestComplete', updateUiState);
  }
  
  /**
   * If a user changes the number of tickets that can affect the custom pickup price.  Ensure that
   * the custom pickup item matches what's expected.
   */
  function replaceInvalidCustomPickup() {
    var item = getCustomPickupCartItem();
    if (!item || item.handle == customPickupHandle) { return; }

    CartJS.removeItem(item.lineNumber);
    CartJS.addItem(customPickupVariant);
    refreshAfterCartJsUpdate();
  }
  
  function updateUiState() {
    if (hasPickupCartItem()) {
      $locationForm.removeClass('shown');
      displayLocationPanel();
      $showButton.hide();
      $removeButton.show();
    }
    else {
      $locationPanel.removeClass('shown');
      $showButton.show();
      $showButton.prop('disabled', false);
      $removeButton.hide();
    }
  }  
  
  function init() {
    $customPickup = $('.cartOption--customPickup');
    
    if (!$customPickup.length) { return; }    
    
    $showButton = $customPickup.find('.customPickup__showBtn');
    $removeButton = $customPickup.find('.customPickup__removeBtn');
    $locationPanel = $customPickup.find('.customPickup__locationPanel');
    $locationDescription = $customPickup.find('.customPickup__locationDescription');
    $locationForm = $customPickup.find('.customPickup__locationForm');
    $noAddressCheckbox = $customPickup.find('#chk_customPickup_noAddress');

    customPickupHandle = $customPickup.data('custom-pickup-handle');
    customPickupVariant = $customPickup.data('custom-pickup-variant');
    customPickupCity = $customPickup.data('custom-pickup-location');
    
    $showButton.on('click', showLocationForm);
    $customPickup.find('.customPickup__cancelBtn').on('click', hideLocationForm);
    $customPickup.find('.customPickup__removeBtn').on('click', removeCustomPickup);
    $customPickup.find('.customPickup__confirmBtn').on('click', confirmCustomPickup);
    $customPickup.find('.customPickup__editBtn').on('click', editLocationForm);
    $noAddressCheckbox.on('change', toggleNoAddressCheckbox);
    
    replaceInvalidCustomPickup();
    
    toggleNoAddressCheckbox();
    updateUiState();
  }
  
  $(document).on('cart.ready', init);
})(jQuery);